import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 41"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#i-1086730658__a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#00AF86",
    "fill-rule": "evenodd",
    d: "M32.462 11.641V3.333H62v8.308H51.385v25.846h-8.308V11.641H32.462ZM2 11.641V3.333h29.538v8.308H20.923v25.846h-8.308V11.641H2Z",
    "clip-rule": "evenodd"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "i-1086730658__a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M2 3.333h60v34.155H2z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }